﻿import * as Decimal from "decimal.js";
import NumberHelper from './../../../Shared/Helpers/numberHelper';
import MoneyTransferAmountHelper from '../Helpers/moneyTransferAmountHelper';
import '../../LegacyScripts/fonmoney_amount';

var fee = window.transferSummary.fee;
var exchangeRate = window.transferSummary.exchangeRate;
var senderCurrency = window.transferSummary.senderCurrency;
var receiverCurrency = window.transferSummary.receiverCurrency;
window.fonmoney_amount.init(exchangeRate, senderCurrency, receiverCurrency, window.transferSummary.feePercentageByProduct);

window.updateAmount = function (sentAmount, receivedAmount) {
    var $ = jQuery;
    var senderCurrency = $("#senderCurrency").val();
    var receiverCurrency = $("#receiverCurrency").val();

    var sentAmount = $("#senderAmount").val();
    var receivableAmount = $("#receiverAmount").val();

    sentAmount = NumberHelper.roundUp(new Decimal(NumberHelper.toInvariantCultureNumberString(sentAmount)));
    fee = NumberHelper.roundUp(new Decimal(NumberHelper.toInvariantCultureNumberString(fee)));

    $("#amount-sending").text(MoneyTransferAmountHelper.roundSenderAmount(sentAmount, senderCurrency) + " " + senderCurrency);
    $("#amount-receivable").text(MoneyTransferAmountHelper.roundReceiverAmount(receivableAmount, receiverCurrency) + " " + receiverCurrency);

    window.fonmoney_amount.updateSummary();
};

window.updateTransferSummaryHeader = function (sentAmount, receivedAmount, senderCurrency, receiverCurrency, exchangeRate, feeAmount, header) {
    var total = NumberHelper.roundUp(new Decimal(NumberHelper.toInvariantCultureNumberString(sentAmount)).add(new Decimal(NumberHelper.toInvariantCultureNumberString(feeAmount))));

    sentAmount = new Decimal(NumberHelper.toInvariantCultureNumberString(sentAmount));
    feeAmount = new Decimal(NumberHelper.toInvariantCultureNumberString(feeAmount));
    receivedAmount = new Decimal(NumberHelper.toInvariantCultureNumberString(receivedAmount));
    fee = feeAmount;

    jQuery("#senderCurrency").val(senderCurrency);
    jQuery("#amount-sending").text(MoneyTransferAmountHelper.roundSenderAmount(sentAmount, senderCurrency) + " " + senderCurrency);
    jQuery("#amount-fee").text(MoneyTransferAmountHelper.roundSenderAmount(feeAmount, senderCurrency) + " " + senderCurrency);
    jQuery("#amount-total").text(MoneyTransferAmountHelper.roundSenderAmount(total, senderCurrency) + " " + senderCurrency);
    jQuery("#amount-receivable").text(receivedAmount + " " + receiverCurrency);
    jQuery("#exchange-rate").text("1 " + senderCurrency + " = " + exchangeRate + " " + receiverCurrency);

    if (header) {
        var headerElement = jQuery("#transferSummaryHeader > h3");
        if (headerElement && headerElement.length)
            headerElement.innerHTML = header;
    }
};

window.updateReceiverCurrencyTransferSummaryHeader = function (senderCurrency, receiverAmount, receiverCurrency, exchangeRate) {

    receiverAmount = receiverAmount.toFixed(2);
    exchangeRate = exchangeRate.toFixed(4);

    jQuery("#amount-receivable").text(MoneyTransferAmountHelper.roundReceiverAmount(receiverAmount, receiverCurrency) + " " + receiverCurrency);
    jQuery("#exchange-rate").text("1 " + senderCurrency + " = " + exchangeRate + " " + receiverCurrency);

}

window.updateCountryInTransferSummaryHeader = function (header) {

    jQuery("#transferSummaryHeader").find("h3")[0].innerHTML = header;
};
window.updateTotalAmount = function (value) {

    jQuery("#amount-total").innerHTML = value + senderCurrency;
};
window.updateReceiverAmount = function (value) {

    updateTotalAmount(value / exchangeRate + fee);
};
window.getStringHtml = function (value, currency) {
    return value + " " + currency;
};
var phoneNumberInput = jQuery('#phoneNumber');
if (phoneNumberInput.length) {
    var transferSummaryHeader = jQuery('#transferSummaryHeader');
    transferSummaryHeader.show();
}